import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { integrationApiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";

export type LoginWithSSORequest = {
  email: string;
};

export type LoginWithSSOResult = {
  url?: string;
};

const loginWithSSORequest = async (payload: LoginWithSSORequest) => {
  const url = `${integrationApiV1Endpoint}/integration/sso/azure/url`;

  const response = await axios.post<ApiResponse<LoginWithSSOResult>>(url, payload, {
    headers: { appname: "institutionalLandlordPortal" },
  });
  return response.data.result;
};

type UseSsoSignInOptions = {
  onSuccess?: (data: LoginWithSSOResult) => void;
  onError?: (error: unknown) => void;
};

export const useLoginWithSSO = (options: UseSsoSignInOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: loginWithSSORequest,
    onSuccess,
    onError,
  });

  return {
    ...rest,
    loginWithSSO: mutateAsync,
  };
};
